import React, { useReducer, useEffect, useState } from "react"
import "./style.scss"
import Modal from "react-bootstrap/Modal"
import SucessModal from "../successModal/successModal"
import { getCountryCallingCode } from "react-phone-number-input"
import Button from "../../elements/button/Button"
import { useLocation } from "@reach/router"
import Spinner from "react-bootstrap/Spinner"
import {
  TiSocialFacebook,
  TiSocialTwitter,
  TiSocialLinkedin,
  TiSocialYoutube,
} from "react-icons/ti"
import { FaPinterest } from "react-icons/fa"
import { FiInstagram } from "react-icons/fi"
import PhoneInput from "../../elements/phoneInput/Input"
import { requestService } from "../../../services"
import { formatNumber, validateEmail } from "../../../utils"

const Requestdemo = ({ show, onHide }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company_name: "",
      country_code: "+1",
      requesting: false,
      response: "",
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
        onHide()
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const socials = [
    {
      name: "fb",
      url: "https://www.facebook.com/brandanalyticstools",
      alt: "fb",
      src: <TiSocialFacebook color="rgba(29,29,29,0.8)" />,
    },
    {
      name: "twitter",
      url: "https://twitter.com/WerselBA",
      alt: "twitter",
      src: <TiSocialTwitter className="mr-2" color="rgba(29,29,29,0.8)" />,
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/company/werselbrandanalytics/",
      alt: "linkedin",
      src: <TiSocialLinkedin className="mr-2" color="rgba(29,29,29,0.8)" />,
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/werselbrandanalytics/",
      alt: "instagram",
      src: <FiInstagram className="mr-2" color="rgba(29,29,29,0.8)" />,
    },
    {
      name: "youtube",
      url: "https://www.youtube.com/channel/UCu-mi8y8XOuFD42WoimkmMg",
      alt: "youtube",
      src: <TiSocialYoutube className="mr-2" color="rgba(29,29,29,0.8)" />,
    },
    {
      name: "pinterest",
      url: "https://www.pinterest.com/brandanalytics/",
      alt: "pinterest",
      src: <FaPinterest className="mr-2" color="rgba(29,29,29,0.8)" />,
    },
  ]
  let location = useLocation()
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }

  const submit = async () => {
    setDetails({ submitted: true })
    const { company_name, name, phone, email, company, country_code } = details
    let data
    if (
      company_name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      name !== "" &&
      validateEmail(email)
    ) {
      let number = formatNumber(phone)
      data = {
        form_name: "request demo form",
        page_url: location.pathname,
        section_name: "header",
        company_name: company_name,
        email,
        name,
        country_code,
        phone_number: number,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.requestDemo(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company_name: "",
          country_code: "",
          requesting: false,
          submitted: false,
          response: result && result.more_info,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Modal
      size="lg"
      dialogClassName="modal-large"
      show={show}
      className="demo"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton></Modal.Header>
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <div className="content request-demo">
        <h1 className="title">
          Connect with our experts to discuss your challenges
        </h1>
        <div className="d-flex flex-wrap align-items-center group">
          <div className="group-item">
            <FormItem
              name="name"
              onChange={onChange}
              value={details.name}
              type="text"
              label="Name"
              inputClassName="inputText"
              error={
                details.submitted &&
                details.name === "" &&
                "Name cannot be empty"
              }
            />
          </div>
          <div className="group-item">
            <FormItem
              name="company_name"
              onChange={onChange}
              value={details.company_name}
              type="text"
              label="Company name"
              inputClassName="inputText"
              error={
                details.submitted &&
                details.company_name === "" &&
                "Company name cannot be empty"
              }
            />
          </div>
        </div>
        <div className="group">
          <div className="group-item">
            <FormItem
              type="tel"
              phone
              onChange={handleNumberSelect}
              getCountryCode={getCountryCode}
              value={details.phone}
              error={
                details.submitted &&
                details.phone === "" &&
                "Phone cannot be empty"
              }
            />
          </div>
          <div className="group-item">
            <FormItem
              name="email"
              onChange={onChange}
              value={details.email}
              type="email"
              label="Email"
              inputClassName="inputText"
              error={
                (details.submitted &&
                  details.email === "" &&
                  "Email cannot be empty") ||
                (details.submitted &&
                  !validateEmail(details.email) &&
                  "Email not valid")
              }
            />
          </div>
        </div>
        <div className="bottom-area">
          <Button onClick={submit}>
            Submit &nbsp;
            {details.requesting && <Spinner animation="border" size="sm" />}
          </Button>
          <p>Connect with us</p>
          <div className="socials">
            {socials &&
              socials.map((social, idx) => {
                return (
                  <a key={idx} href={social.url}>
                    {social.src}
                  </a>
                )
              })}
          </div>
        </div>
      </div>
    </Modal>
  )
}
const FormItem = ({
  label,
  error,
  phone,
  onChange,
  getCountryCode,
  ...props
}) => {
  return (
    <div className={`form-item ${error ? "has-error" : ""}`}>
      {!phone && (
        <div>
          <input
            name={props.name}
            onChange={onChange}
            value={props.value}
            type={props.type}
            className={props.inputClassName}
            required
          />
          {error && <p className={"error-message"}>{error}</p>}
        </div>
      )}
      {phone && (
        <div className="phone_input">
          <PhoneInput
            onChange={onChange}
            getCountryCode={getCountryCode}
            value={props.value}
          />
          {error && <p className={"error-message phone"}>{error}</p>}
        </div>
      )}
      <span className="floating-label">{label}</span>
    </div>
  )
}

export default Requestdemo
